<template>
  <div style="background: #1f1c1f;min-height:100vh;">
    <div class="header">
      <div class="header_content">
        <div @click="$router.back()" style="color:#e6b98a;font-size:28px;">
            <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
        </div>
        <div class="img_c" style="color: #e6b98a; font-size: 16px; font-weight:bold;">
          {{$t("choose.vote_history_title")}}
        </div>
        <div></div>
      </div>
    </div>

    <div class="history_list">
      <!-- 骨架屏 -->
      <van-skeleton
        v-if="loading"
        row="4"
        title-width="60%"
        class="skeleton"
      />

      <!-- 无投票记录 -->
      <van-empty v-else-if="historyList.length===0" :description="$t('choose.no_vote_history')" />

      <!-- 投票历史列表 -->
      <template v-else>
        <div class="history_item" v-for="item in historyList" :key="item.id">
          <div class="history_left">
            <div class="no">{{ item.no_code }}</div>
            <div class="name">{{ item.xuanfei_name }}</div>
          </div>
          <div class="history_right">
            <div class="num">{{ $t("choose.vote_count", { count: item.vote_num }) }}</div>
            <div class="time">{{ item.create_time }}</div>
          </div>
        </div>
      </template>
    </div>

    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading:true,
      historyList:[]
    }
  },
  mounted() {
    this.getVoteHistory()
  },
  methods:{
    getVoteHistory(){
        this.loading=true
      this.$http({
        method:"get",
        url:"getUserVoteLog"
      }).then(res=>{
        if(!localStorage.getItem('token')){
          this.$router.push({path:'/Login'})
          return
        }
        this.historyList = res.data || []
      }).finally(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.history_list{
  padding-top:120px;
  padding:120px 20px 40px;
}
.history_item{
  margin:20px 4px;
  padding:24px;
  border-radius:20px;
  background:linear-gradient(120deg,#212121,#313131);
  border:1px solid #766350;
  display:flex;
  justify-content:space-between;
  align-items:center;
  .history_left{
    .no{
      font-size:28px;
      color:#efcba7;
      font-weight:bold;
    }
    .name{
      font-size:26px;
      color:#ddd;
      margin-top:8px;
    }
  }
  .history_right{
    text-align:right;
    .num{
      font-size:28px;
      color:#efcba7;
      font-weight:bold;
    }
    .time{
      font-size:22px;
      color:#999;
      margin-top:8px;
    }
  }
}
.skeleton{
  padding:20px;
  margin:20px 4px;
  background:linear-gradient(120deg,#212121,#313131);
  border-radius:20px;
}
.header {
  height: 13vw;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  background-color: #1f1c1f;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 20px;
  color: #fff;
}
</style>
